/**
 * Componentes reutilizables de inputs con contador de caracteres
 * 
 * Estos componentes facilitan la creación de inputs con contador de caracteres
 * de forma consistente en toda la aplicación.
 * 
 * @example
 * // Import individual
 * import { TextFieldWithCounter } from 'components/ui/commons/inputs';
 * 
 * @example
 * // Import múltiple
 * import { TextFieldWithCounter, InputWithCounter } from 'components/ui/commons/inputs';
 */

export { default as TextFieldWithCounter } from './TextFieldWithCounter';
export { default as InputWithCounter } from './InputWithCounter';

/**
 * Utilidad para limitar la cantidad de dígitos de montos numéricos.
 * Por defecto limita a 11 dígitos en la parte entera y 2 en la decimal.
 */
export const limitMontoDigits = (value, maxIntegerDigits = 11, maxDecimalDigits = 2) => {
	if (value === '' || value === null || value === undefined) {
		return value;
	}
	let str = value.toString();
	// Solo dígitos y un punto decimal
	str = str.replace(/[^\d.]/g, '');
	const parts = str.split('.');
	let intPart = parts[0] || '';
	let decPart = parts[1] || '';
	intPart = intPart.slice(0, maxIntegerDigits);
	decPart = decPart.slice(0, maxDecimalDigits);
	return decPart.length ? `${intPart}.${decPart}` : intPart;
};

